import { __awaiter } from "tslib";
import { ServiceNodeService } from "@/services/models/service_node";
const moduleServiceNode = {
    namespaced: true,
    state: {
        service_node: [],
        loading: false,
        selected_service_node_id: 0,
    },
    getters: {
        getServiceNode: (state) => state.service_node,
        getLoading: (state) => state.loading,
        getSelectedServiceNodeId: (state) => state.selected_service_node_id,
    },
    mutations: {
        setServiceNode: (state, service_node) => (state.service_node = service_node),
        setLoading: (state, loading) => (state.loading = loading),
        setSelectedServiceNodeId: (state, selected_service_node_id) => (state.selected_service_node_id = selected_service_node_id),
    },
    actions: {
        loadServiceNodeByNodeId({ commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                let service_node = yield ServiceNodeService.getByDestinationNodeV2(id);
                service_node = service_node.map((data) => {
                    var _a;
                    let fullName;
                    if (data.service_id != null && service_node.filter((f) => f.service_id == data.service_id).length > 1) {
                        fullName = `${data.name} - ${((_a = data.specialty_node) === null || _a === void 0 ? void 0 : _a.name) || "Sin información"}`;
                    }
                    else {
                        fullName = `${data.name}`;
                    }
                    return Object.assign(Object.assign({}, data), { fullName: fullName });
                });
                commit("setServiceNode", service_node);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleServiceNode;
